import React, { useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import RowsIcon from "../../../../media/images/icons/rows-icons";
import ButtonTabbar from "../../../components/ButtonTabbar";
import ActiveFeright from "./ActiveFeright";

export default function ManageFreights() {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const tabbuttons = [
    {
      title: "بارهای فعال",
    },
    {
      title: "تکمیل‌شده",
    },
    {
      title: "لغو‌شده",
    },
  ];

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            مدیریت بارها{" "}
          </Typography>
        }
        hasScroll={false}
      />
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          paddingX: "16px",
          paddingBottom: "16px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            backgroundColor: "background.default",
            padding: "16px",
            borderColor: "#CFD8DC",
            borderWidth: "2px",
            borderStyle: "solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
              gap: "8px",
            }}
          >
            <RowsIcon color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontFamily: "YeBakh-Bold",
                color: "primary.main",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              مدیریت بارها
            </Typography>
          </Box>
          <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          />
        </Box>
        <ActiveFeright />
      </Box>
      <BottomTabbar />
    </>
  );
}
